import React from 'react';
import { Card, Tag, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Contrato de GET /api/professor/avaliacoes/turmas/{id}/alunos
// (AlunoAvaliacaoTurmaProfessorResponse): id_avaliacao_aluno, id_matricula,
// nome_aluno, status, possui_comentario. Terminologia amigável só no
// label visual -- o valor cru (PENDENTE/RASCUNHO/AGUARDANDO_VALIDACAO/
// PUBLICADA) nunca muda, é só o que é enviado de volta ao clicar/navegar.
// Fase 12: PUBLICADA só é alcançada via validação administrativa, nunca
// mais diretamente pelo professor.

export const STATUS_ALUNO_AVALIACAO_INFO = {
  PENDENTE: { label: 'Não iniciada', color: 'default' },
  RASCUNHO: { label: 'Em andamento', color: 'gold' },
  AGUARDANDO_VALIDACAO: { label: 'Aguardando validação', color: 'blue' },
  PUBLICADA: { label: 'Publicada', color: 'green' },
};

const AlunoAvaliacaoProfessorCard = ({ aluno, onAbrir }) => {
  const statusInfo = STATUS_ALUNO_AVALIACAO_INFO[aluno.status] || { label: aluno.status, color: 'default' };

  return (
    <Card
      className="portal-professor__card"
      hoverable
      onClick={() => onAbrir(aluno)}
      data-testid="aluno-avaliacao-card"
    >
      <div className="portal-professor__card-row">
        <Text strong style={{ fontSize: 16, wordBreak: 'break-word', flex: '1 1 auto', minWidth: 0 }}>
          {aluno.nome_aluno}
        </Text>
        <Tag color={statusInfo.color} aria-label={`Status: ${statusInfo.label}`}>
          {statusInfo.label}
        </Tag>
        <RightOutlined style={{ color: '#bfbfbf' }} aria-hidden="true" />
      </div>
    </Card>
  );
};

export default AlunoAvaliacaoProfessorCard;
